export const MAX_FILE_SIZE = 1000000000;
export const USE_INTERVAL_DELAY = 2000;
